module.exports = __webpack_public_path__ + "static/media/pencil.23ae41e1.svg";